export default "__VITE_PUBLIC_ASSET__eb6c6632__"